<!--
 * @Description: 线索公海池
 * @Author: mdb
 * @Date: 2022-07-06 11:24:43
 * @LastEditTime: 2023-07-04 16:14:47
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <cos-table
        serial
        rowKey="clueId"
        :row-selection="{ onChange: onSelectRowsChange }"
        :columns="columns"
        v-model:search="queryForm"
        @mask="showMask"
        @fetch="getList"
        ref="tableRef"
        tableId="DcCosLbuPublicClue"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item label="线索ID">
              <a-input v-model:value="queryForm.clueId" :maxlength="200" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="客户名称">
              <a-textarea
                v-model:value="queryForm.customerName"
                :autoSize="{ minRows: 1, maxRows: 4 }"
                placeholder="请输入"
              />
            </dc-form-item>
            <dc-form-item label="联系方式">
              <a-input-group compact>
                <a-select v-model:value="queryForm.contact.type" style="width: 33%" placeholder="请选择">
                  <a-select-option :value="1">手机号</a-select-option>
                  <a-select-option :value="2">固定电话</a-select-option>
                  <a-select-option :value="3">邮箱</a-select-option>
                  <a-select-option :value="4">微信号</a-select-option>
                  <a-select-option :value="5">qq</a-select-option>
                </a-select>
                <a-input
                  v-model:value="queryForm.contact.keyword"
                  :maxlength="100"
                  style="width: 67%"
                  placeholder="请输入"
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item label="前负责人">
              <UserSelect v-model:value="queryForm.beforeFollowerList" placeholder="请选择" mode="multiple" allowClear />
            </dc-form-item>
            <dc-form-item label="客户区域">
              <CustomerAreaCascader type="search" appId="cos_lbu" v-model:ids="queryForm.customerRegionList" />
            </dc-form-item>
            <dc-form-item label="来源渠道">
              <a-input-group compact>
                <ParamCodeCascader
                  type="search"
                  v-model:ids="queryForm.channelList"
                  appId="cos_lbu"
                  paramCode="lbu_source_channel"
                  style="width: 33%"
                />
                <a-input
                  v-model:value="queryForm.channelExplain"
                  :maxlength="100"
                  style="width: 67%"
                  placeholder="请输入"
                  allowClear
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item name="timeType" label="时间筛选">
              <a-input-group compact>
                <a-select v-model:value="queryForm.timeSearch.type" style="width: 33%">
                  <a-select-option :value="1">创建时间</a-select-option>
                  <a-select-option :value="2">首次领取时间</a-select-option>
                  <a-select-option :value="3">最后一次领取时间</a-select-option>
                  <a-select-option :value="4">转为潜在时间</a-select-option>
                </a-select>
                <CosRangePicker
                  v-model:startTime="queryForm.timeSearch.startTime"
                  v-model:endTime="queryForm.timeSearch.endTime"
                  style="width: 67%"
                />
              </a-input-group>
            </dc-form-item>
            <!-- <dc-form-item label="未跟进天数">
              <a-select
                v-model:value="queryForm.notFollowDayNumType"
                :options="customerUnfollowDayTypeEnum"
                placeholder="请选择"
                allowClear
              />
            </dc-form-item> -->
            <dc-form-item label="客户识别码">
              <a-input v-model:value="queryForm.customerSerial" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="客户标签">
              <CustomerLabelCascader type="search" :onlyCommon=false appId="cos_lbu" v-model:ids="queryForm.labelIdList" allowClear/>
            </dc-form-item>
            <dc-form-item label="业务类型">
              <a-select
                v-model:value="queryForm.businessTypeList"
                :options="businessTypeEnum"
                placeholder="请选择"
                mode="multiple"
                allowClear
              />
            </dc-form-item>
          </a-form>
        </template>

        <template #button>
          <a-button v-permission="'lbu_public_clue_assign_btn'" type="primary" @click="handleAssignPerson()"
            >分配线索</a-button
          >
           <clue-merge-button
            :data="selectedData"
            v-permission="'lbu_public_clue_merge_btn'"
            appId="cos_lbu"
            @success="handleQueryChange('fetch')"
            >合并</clue-merge-button
          >
          <a-button v-permission="'lbu_public_clue_receive_btn'" @click="handleReceive()">领取线索</a-button>
          <ExportButton
            v-permission="'lbu_public_clue_export_btn'"
            appId="cos_lbu"
            taskType="302"
            :search="handledQueryParams(queryForm)"
            >导出</ExportButton
          >
        </template>

        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'channel'">
            <ChannelText appId="cos_lbu" paramCode="lbu_source_channel" :value="text" :desc="record.channelExplain" />
          </template>
          <template v-if="column.dataIndex === 'customerRegion'">
            <CustomerAreaCascaderText appId="cos_lbu" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'label'">
            <p>{{ record.label ? record.label.map((item) => item.labelName ).join('、') : '--' }}</p>
          </template>
          <template v-if="column.type === 'money'">
            <p>{{ formatThousandSeparator(text)}}</p>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <a-button v-permission="'lbu_public_clue_assign_btn'" type="link" @click="handleAssignPerson(record)"
              >分配线索</a-button
            >
            <a-button v-permission="'lbu_public_clue_receive_btn'" type="link" @click="handleReceive(record)"
              >领取线索</a-button
            >
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>

  <!-- 分配客户负责人弹窗 -->
  <ClueAssign ref="clueAssignRef" @fetch="handleQueryChange('fetch')" />
</template>

<script setup lang="ts">
import { reactive, computed, ref, onMounted, toRaw } from 'vue'
import { useRoute } from 'vue-router'
import { Modal as AModal } from 'ant-design-vue'
import { message } from '@dc-platform/dc-components'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import ClueMergeButton from '@/components/ClueMergeButton'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import ClueAssign from '../components/ClueAssign.vue'
import { businessTypeEnum, customerUnfollowDayTypeEnum, customerTypeEnum } from '@/views/yuntuSales/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import { customerListFormat } from '@/utils'
import { infoData } from '@/api/gucangSales/followRuleSetting'
import { publicClueList, publicClueCollect, salesClueDetail } from '@/api/yuntuSales/clueManage'
import type { ParamCodeItem } from '@/typings/common'
import type { LbuPublicClueParams, LbuPublicClueListItem } from '@/typings/api/clueManage'
import CustomerLabelCascader from '@/components/CustomerLabelCascader/index.vue'
import formatThousandSeparator from '@/utils/format'
const route = useRoute()

const paramCodeData: {
  [key: string]: ParamCodeItem[]
} = reactive({
  lbu_follow_purpose: [], // 拜访目的
  lbu_follow_mode: [], // 拜访方式（跟进方式）
  lbu_customer_business_area: [], // 客户业务区域
  lbu_important: [], // 月潜在收入
  lbu_sales_category: [], // 销售品类
  lbu_cargo_type: [], // 货物类型
  lbu_logistics_service_provider: [], // 现有合作物流服务商
  lbu_shipping_channel: [], // 出货渠道
  lbu_daily_traffic: [] // 客户日均包裹数量
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: [
      'lbu_follow_purpose',
      'lbu_follow_mode',
      'lbu_customer_business_area',
      'lbu_important',
      'lbu_sales_category',
      'lbu_cargo_type',
      'lbu_logistics_service_provider',
      'lbu_shipping_channel',
      'lbu_daily_traffic'
    ]
  }).then((res) => {
    Object.assign(paramCodeData, res.data)
  })
}
const clueRuleList = ref<string[]>([])
const getFollowRuleInfo = async () => {
  const { data } = await infoData({ appId: 'cos_lbu', configType: 3 })
  clueRuleList.value = (data as any).CLUE_RULE_2.split(',')
}
onMounted(() => {
  getFollowRuleInfo()
  getByParamCodes()
})

const tableRef = ref()
const queryForm = reactive<LbuPublicClueParams>({ contact: { type: 1 }, timeSearch: { type: 1 } })

const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    cosType: 'link',
    path: '/lbu/salesClue/view',
    query: ['clueId', 'isPublicClue=1', `returnPath=${route.fullPath}`],
    fixed: 'left'
  },
  { title: '客户识别码', dataIndex: 'customerSerial' },
  { title: '客户标签', dataIndex: 'label' },
  {
    title: '业务类型',
    dataIndex: 'businessType',
    dicData: businessTypeEnum
  },
  { title: '线索ID', dataIndex: 'clueId' },
  { title: '来源渠道', dataIndex: 'channel' },
  { title: '前负责人', dataIndex: 'beforeFollowerName' },
  { title: '客户区域', dataIndex: 'customerRegion' },
  { title: '客户类型', dataIndex: 'customerType', dicData: customerTypeEnum },
  { title: '客户合同地址', dataIndex: 'customerAddress' },
  { title: '联系人姓名', dataIndex: ['contact', 'name'], cosType: 'mask' },
  { title: '手机号', dataIndex: ['contact', 'mobile'], cosType: 'mask' },
  { title: '邮箱', dataIndex: ['contact', 'email'], cosType: 'mask' },
  { title: '微信号', dataIndex: ['contact', 'wechat'], cosType: 'mask' },
  { title: 'QQ号', dataIndex: ['contact', 'qq'], cosType: 'mask' },
  { title: '固定电话', dataIndex: ['contact', 'tel'], cosType: 'mask' },
  { title: '备注', dataIndex: 'remark' },
  // { title: '业务地区', dataIndex: ['business', 'businessArea'], dicData: paramCodeData.lbu_customer_business_area },
  { title: '业务收入等级', dataIndex: ['business', 'monthIncome'], dicData: paramCodeData.lbu_important },
  { title: '年销售GMV(元)', dataIndex: ['business', 'annualSales'], type: 'money', sorter: true, width: 160 },
  // { title: '销售品类', dataIndex: ['business', 'salesCategory'], dicData: paramCodeData.lbu_sales_category },
  // { title: '货物类型', dataIndex: ['business', 'cargoType'], dicData: paramCodeData.lbu_cargo_type },
  // {
  //   title: '现有合作物流服务商',
  //   dataIndex: ['business', 'cooperativeLogistics'],
  //   dicData: paramCodeData.lbu_logistics_service_provider
  // },
  // { title: '出货渠道', dataIndex: ['business', 'deliveryChannel'], dicData: paramCodeData.lbu_shipping_channel },
  // { title: '客户日均包裹数量', dataIndex: ['business', 'dailyTraffic'], dicData: paramCodeData.lbu_daily_traffic },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime', width: 190, sorter: true },
  { title: '首次领取时间', dataIndex: 'firstReceiveTime', width: 190, sorter: true },
  { title: '最后一次领取时间', dataIndex: 'lastReceiveTime', width: 190, sorter: true },
  { title: '流转公海池时间', dataIndex: 'transferTime', width: 190, sorter: true },
  { title: '操作', dataIndex: 'action', width: 200, fixed: 'right' }
])

const handledQueryParams = (params: LbuPublicClueParams) => {
  const queryForm = customerListFormat(params) // 处理客户名称和客户编码的批量查询参数
  const contacts = queryForm.contact?.keyword?.split(/[,，\s\n]/).filter((e: string) => e)
  if (contacts && contacts.length > 1) {
    queryForm.contact.keywordList = contacts
    delete queryForm.contact.keyword
  }
  return queryForm
}
const getList = (queryForm: LbuPublicClueParams, callBack: (res: any) => void) => {
  const params = handledQueryParams(queryForm) // 处理客户名称的批量查询参数

  const clueId = queryForm.clueId
  if (clueId !== undefined && clueId.length > 0) {
    params.clueIdList = clueId.split(' ')
    params.clueId = undefined
  }

  const customerSerial = queryForm.customerSerial
  if (customerSerial !== undefined && customerSerial.length > 0) {
    params.customerSerialList = customerSerial.split(' ')
    params.customerSerial = undefined
  }

  publicClueList(params).then((res) => {
    res.data.items.forEach((item: LbuPublicClueListItem) => {
      if (item.business?.monthIncome === 0) {
        item.business.monthIncome = undefined
      }
    })
    callBack(res)
  })
}
// 获取详情联系人信息
const showMask = (record: LbuPublicClueParams, callBack: (res: any) => void) => {
  salesClueDetail({ clueId: record.clueId as string }).then((res) => {
    const { contact } = res.data
    callBack(contact)
  })
}
const handleQueryChange = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}

const selectedData = ref<LbuPublicClueListItem[]>([])
const onSelectRowsChange = (selectedRowKeys: string[], selectedRows: LbuPublicClueListItem[]) => {
  selectedData.value = selectedRows
}

// 分配客户负责人
const clueAssignRef = ref()
const handleAssignPerson = (row?: LbuPublicClueListItem) => {
  if (!row && !selectedData.value?.length) return message.warning('请选择需要分配的线索')
  const data = row ? [row] : toRaw(selectedData.value)
  clueAssignRef.value?.init(data)
}
// 领取线索
const handleReceive = (row?: LbuPublicClueListItem) => {
  if (!row && !selectedData.value?.length) {
    return message.warning('请选择需要领取的线索')
  }
  const clueIdList: any[] = []
  if (row) {
    clueIdList.push(row.clueId)
  } else {
    selectedData.value.forEach((item) => {
      clueIdList.push(item.clueId)
    })
  }
  AModal.confirm({
    title: '是否确认领取所选择的线索？',
    content: `领取后${clueRuleList.value[0]}个工作日内未写${clueRuleList.value[1]}条跟进记录,线索会自动退回到公海池`,
    okText: '领取',
    onOk() {
      publicClueCollect({ clueIdList }).then(() => {
        message.success('领取成功')
        tableRef.value?.fetch()
      })
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onCancel() {}
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuPublicClue' }
</script>

<style scoped></style>
